import { CONSTANTS } from '../data.js';

export const getBreedingRecipe = (dragonName) => {
  return CONSTANTS.BREEDING_COMBINATIONS[dragonName] || null;
};

export const canBreedDragons = (selectedBreedingDragons, playerDragons) => {
  if (selectedBreedingDragons.length !== 2) return false;
  
  const dragon1 = playerDragons.find(d => d.id === selectedBreedingDragons[0]);
  const dragon2 = playerDragons.find(d => d.id === selectedBreedingDragons[1]);
  
  if (!dragon1 || !dragon2) return false;

  if (dragon1.name === dragon2.name && dragon1.level === dragon2.level && dragon1.level >= CONSTANTS.MAX_DRAGON_LEVEL) {
    return false;
  }

  return true;
};

export const processBreeding = (selectedBreedingDragons, playerDragons, coins) => {
  if (selectedBreedingDragons.length !== 2) {
    return { success: false, error: 'Select exactly 2 dragons to combine.' };
  }

  const dragon1 = playerDragons.find(d => d.id === selectedBreedingDragons[0]);
  const dragon2 = playerDragons.find(d => d.id === selectedBreedingDragons[1]);
  
  if (!dragon1 || !dragon2) {
    return { success: false, error: 'Dragons not found.' };
  }

  // Case 1: Same dragon type (leveling up)
  if (dragon1.name === dragon2.name) {
    if (dragon1.level === dragon2.level) {
      if (dragon1.level < CONSTANTS.MAX_DRAGON_LEVEL) {
        const nextLevel = dragon1.level + 1;
        const newDragons = [
          ...playerDragons.filter(d => !selectedBreedingDragons.includes(d.id)),
          { id: Date.now(), name: dragon1.name, level: nextLevel }
        ];
        return {
          success: true,
          newDragons,
          newCoins: coins,
          result: {
            type: 'level_up',
            name: dragon1.name,
            level: nextLevel,
          }
        };
      } else {
        return {
          success: false,
          error: `${dragon1.name} is already at the maximum level.`,
          newDragons: playerDragons,
          newCoins: coins
        };
      }
    } else {
      // Different levels penalty
      const [lowerLevelDragon, higherLevelDragon] = dragon1.level < dragon2.level ? [dragon1, dragon2] : [dragon2, dragon1];
      const newDragons = playerDragons.map(d => 
        d.id === higherLevelDragon.id ? { ...d, level: lowerLevelDragon.level } : d
      );
      return {
        success: false,
        penalty: {
          title: 'Level Revert Penalty!',
          message: `Failed combination! ${higherLevelDragon.name} (Lvl ${higherLevelDragon.level}) reverted to Level ${lowerLevelDragon.level}.`
        },
        newDragons,
        newCoins: coins
      };
    }
  }

  // Case 2: Different dragon types (recipe breeding)
  let resultName = null;
  for (const [result, parents] of Object.entries(CONSTANTS.BREEDING_COMBINATIONS)) {
    if (parents.length === 2) {
      const [parent1, parent2] = parents;
      if ((dragon1.name === parent1 && dragon2.name === parent2) ||
          (dragon1.name === parent2 && dragon2.name === parent1)) {
        resultName = result;
        break;
      }
    }
  }

  if (resultName) {
    const newDragons = [
      ...playerDragons.filter(d => !selectedBreedingDragons.includes(d.id)),
      { id: Date.now(), name: resultName, level: 1 }
    ];
    return {
      success: true,
      newDragons,
      newCoins: coins,
      result: {
        type: 'new_dragon',
        name: resultName,
        level: 1,
      },
      newUnlock: resultName,
    };
  } else {
    // Failed recipe breeding
    const dragon1Data = CONSTANTS.DRAGONS[dragon1.name];
    const dragon2Data = CONSTANTS.DRAGONS[dragon2.name];

    if (dragon1Data.rarity === dragon2Data.rarity) {
      const rarity = dragon1Data.rarity;
      const penaltyPercent = CONSTANTS.FAILED_BREEDING_PENALTY[rarity] || 0;
      const penaltyAmount = Math.floor(coins * penaltyPercent);
      return {
        success: false,
        penalty: {
          title: 'Combination Failed!',
          message: `You lost ${penaltyAmount.toLocaleString()} coins.`
        },
        newDragons: playerDragons,
        newCoins: coins - penaltyAmount
      };
    } else {
      const rarityOrder = CONSTANTS.RARITY_ORDER;
      const higherRarity = rarityOrder.indexOf(dragon1Data.rarity) > rarityOrder.indexOf(dragon2Data.rarity) ? dragon1Data.rarity : dragon2Data.rarity;
      const penaltyPercent = CONSTANTS.FAILED_BREEDING_PENALTY[higherRarity] || 0;
      const penaltyAmount = Math.floor(coins * penaltyPercent);
      const newDragons = playerDragons.filter(d => !selectedBreedingDragons.includes(d.id));
      return {
        success: false,
        penalty: {
          title: 'Combination Failed!',
          message: `Both dragons were lost and you lost ${penaltyAmount.toLocaleString()} coins.`
        },
        newDragons,
        newCoins: coins - penaltyAmount
      };
    }
  }
};
